import React from "react";
import "./HelperText.scss";

type HelperTextprop = {
  children: string;
};

const HelperText: React.FC<HelperTextprop> = ({ children }) => {
  return (
    <div className="error-helptext" >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
      >
        <path
          d="M4.99935 9.16406C7.29518 9.16406 9.16602 7.29323 9.16602 4.9974C9.16602 2.70156 7.29518 0.830729 4.99935 0.830729C2.70352 0.830729 0.832683 2.70156 0.832683 4.9974C0.832683 7.29323 2.70352 9.16406 4.99935 9.16406ZM5.31185 6.66406C5.31185 6.8349 5.17018 6.97656 4.99935 6.97656C4.82852 6.97656 4.68685 6.8349 4.68685 6.66406L4.68685 4.58073C4.68685 4.4099 4.82852 4.26823 4.99935 4.26823C5.17018 4.26823 5.31185 4.4099 5.31185 4.58073V6.66406ZM4.61602 3.1724C4.63685 3.11823 4.66602 3.07656 4.70352 3.0349C4.74518 2.9974 4.79102 2.96823 4.84102 2.9474C4.89102 2.92656 4.94518 2.91406 4.99935 2.91406C5.05352 2.91406 5.10768 2.92656 5.15768 2.9474C5.20768 2.96823 5.25352 2.9974 5.29518 3.0349C5.33268 3.07656 5.36185 3.11823 5.38268 3.1724C5.40352 3.2224 5.41602 3.27656 5.41602 3.33073C5.41602 3.3849 5.40352 3.43906 5.38268 3.48906C5.36185 3.53906 5.33268 3.5849 5.29518 3.62656C5.25352 3.66406 5.20768 3.69323 5.15768 3.71406C5.05768 3.75573 4.94102 3.75573 4.84102 3.71406C4.79102 3.69323 4.74518 3.66406 4.70352 3.62656C4.66602 3.5849 4.63685 3.53906 4.61602 3.48906C4.59518 3.43906 4.58268 3.3849 4.58268 3.33073C4.58268 3.27656 4.59518 3.2224 4.61602 3.1724Z"
          fill="#DF4B2D"
        />
      </svg>
      {children}
    </div>
  );
};

export default HelperText;
